import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

interface WorkShift {
    active: number;
    createdAt: any;
    endTime: any;
    name: string;
    startTime: any;
    updatedAt: any;
}

interface WorkShiftId extends WorkShift {
    id: string;
}

@Injectable()
export class WorkShiftService {

    workShiftCollection: AngularFirestoreCollection<WorkShift>;
    workShifts: any;

    workShiftDocument: AngularFirestoreDocument<WorkShiftId>;
    workShift: Observable<WorkShiftId>;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.WORK_SHIFT_COLLECTION;
    }

    postWorkShift(workShiftObject: any) {
        this.workShiftCollection = this.afs.collection(this.collection);

        return this.workShiftCollection.add(workShiftObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getWorkShifts() {
        this.workShiftCollection = this.afs.collection(this.collection, ref => ref.orderBy('startTime', 'asc').where('active', '==', 1) );

        this.workShifts = this.workShiftCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as WorkShift;

                const name = data.name;
                const startTime = data.startTime;
                const endTime = data.endTime;

                return { id$, name, startTime, endTime };
            });
        }).map(object => object);

        return this.workShifts;
    }

    getWorkShift(id$: string) {
        this.workShiftDocument = this.afs.doc(this.collection + '/' + id$);

        this.workShift = this.workShiftDocument.valueChanges();

        return this.workShift.map(object => object);
    }

    putWorkShift(workShiftObject: any, id$: string) {
        this.workShiftCollection = this.afs.collection(this.collection);

        return this.workShiftCollection.doc(id$).update(workShiftObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    delWorkShift(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        return this.putWorkShift({active: 0}, id$);
    }

}
